/**
 * Created by Colin.Watson on 4/1/2015.
 */
/// <reference path="../../app.typings.d.ts" />
(function () {
	'use strict';
	angular.module('blocks').config(config);
	config.$inject = ['blocks.ApiEndpointProvider'];
	function config(apiEndpointProvider) {
		apiEndpointProvider.configure('http://localhost:9999');
	}
})();
